<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__title">产品管理</div>
    </div>
    <div class="page-panel__body">
      <el-tabs v-model="activeName">
        <el-tab-pane label="产品管理" name="产品管理">
          <el-form class="page-panel-search-form" :inline="true">
            <!-- <el-form-item>
              <el-input placeholder="请输入关键字"> </el-input>
            </el-form-item>-->
            <!-- <el-form-item>
              <el-button type="default" @click="getThreeLessonsList()" icon="el-icon-search"></el-button>
            </el-form-item>-->
            <el-form-item class="page-panel-search-form-right-button">
              <el-button type="primary" @click="newProduct">新增</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="productList" border stripe>
            <el-table-column type="index" label="序号" width="90" align="center">
              <template
                slot-scope="scope"
              >{{(scope.$index+1)+((searchModel.pageNo-1)*searchModel.pageSize)}}</template>
            </el-table-column>
            <el-table-column prop="proTitle" label="名称" align="center"></el-table-column>
            <el-table-column label="产品效果图" align="center">
              <template slot-scope="scope">
                <img
                  :src="scope.row.picMain"
                  alt="产品效果图"
                  onerror="this.src='/static/img/unload.gif"
                  width="120"
                />
              </template>
            </el-table-column>
            <el-table-column label="产品参数图" align="center">
              <template slot-scope="scope">
                <img
                  :src="scope.row.picPara"
                  alt="产品参数图"
                  onerror="this.src='/static/img/unload.gif"
                  width="120"
                />
              </template>
            </el-table-column>
            <el-table-column align="center" label="是否展示">
              <template slot-scope="scope">
                <el-switch
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="0"
                  :inactive-value="1"
                  v-model="scope.row.isHide"
                  @change="hideProduct(scope.row)"
                  active-text="是"
                  inactive-text="否"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="addTime" label="创建日期" align="center"></el-table-column>
            <el-table-column prop="addUser" label="创建人" align="center" width="80"></el-table-column>
            <el-table-column prop label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="getProductDetail(scope.row.proId,1)">查看</el-button>
                <el-button type="text" @click="getProductDeta3il(scope.row.proId,2)">编辑</el-button>
                <el-button type="text" @click="delProduct(scope.row.proId)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="page-panel__footer">
            <el-pagination
              :current-page.sync="searchModel.pageNo"
              :page-size="searchModel.pageSize"
              layout="prev, pager, next, jumper"
              :total="total"
              @current-change="getProductList"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="产品信息" :visible.sync="viewDialogVisable" :modal="false">
      <table class="form-editor">
        <table class="form-editor">
          <tr>
            <th>产品名称:</th>
            <td colspan="3">{{productParam.proTitle}}</td>
          </tr>
          <tr>
            <th>产品类型:</th>
            <td>
              <el-radio-group v-model="productParam.proType" disabled>
                <el-radio :label="0">产品展示</el-radio>
                <el-radio :label="1">技术服务</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <th>产品效果图:</th>
            <td>
              <img
                :src="productParam.picMain"
                alt="产品效果图"
                onerror="this.src='/static/img/unload.gif"
                width="150"
              />
            </td>
            <th>产品参数图:</th>
            <td>
              <img
                :src="productParam.picPara"
                alt="产品参数图"
                onerror="this.src='/static/img/unload.gif"
                width="150"
              />
            </td>
          </tr>
          <tr>
            <th>产品简介:</th>
            <td colspan="3">
              <div v-html="productParam.proBody"></div>
            </td>
          </tr>
          <tr>
            <th>是否推荐首页:</th>
            <td>
              <el-radio-group v-model="productParam.isRecom">
                <el-radio :label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </td>
          </tr>
        </table>
      </table>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisable" :modal="false" destroy-on-close>
      <table class="form-editor">
        <tr>
          <th>产品名称:</th>
          <td colspan="3">
            <el-input v-model="productParam.proTitle" placeholder="请输入产品名称"></el-input>
          </td>
        </tr>
        <tr>
          <th>产品类型:</th>
          <td>
            <el-radio-group v-model="productParam.proType">
              <el-radio :label="0">产品展示</el-radio>
              <el-radio :label="1">技术服务</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <th>产品效果图:</th>
          <td>
            <el-upload
              class="avatar-uploader"
              action="/file/upload"
              :show-file-list="false"
              :on-success="handleMainSuccess"
              :headers="headers"
            >
              <img v-if="dialogImageMainUrl" :src="dialogImageMainUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </td>
          <th>产品参数图:</th>
          <td>
            <el-upload
              class="avatar-uploader"
              action="/file/upload"
              :show-file-list="false"
              :on-success="handlePraSuccess"
              :headers="headers"
            >
              <img v-if="dialogImagePrarUrl" :src="dialogImagePrarUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </td>
        </tr>
        <tr>
          <th>产品简介:</th>
          <td colspan="3">
            <!-- <ueditor :config="editorConfig" v-model="productParam.proBody"></ueditor> -->
            <editor v-model="productParam.proBody" :min-height="200" />
            <!-- <qeditor :content.sync="productParam.proBody"></qeditor> -->
          </td>
        </tr>
        <tr>
          <th>是否推荐首页:</th>
          <td>
            <el-radio-group v-model="productParam.isRecom">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </td>
        </tr>
      </table>
      <span slot="footer">
        <el-button @click=" dialogVisable= false">取 消</el-button>
        <el-button type="primary" @click="update">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as productApi from '@/api/adminApi/zh/product';
import { localStorage } from '@/common/util/storage';
export default {
  data() {
    return {
      headers: {
        token: localStorage.get('token')
      },
      total: 0,
      searchModel: {
        pageNo: 1,
        pageSize: 10
      },
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 300,
        zIndex: 0
      },
      viewDialogVisable: false,
      dialogImageMainUrl: '',
      dialogImagePrarUrl: '',
      productParam: {
        proType: 0,
        isRecom: 1
      },
      dialogVisable: false,
      dialogTitle: '新增产品信息',
      activeName: '产品管理',
      productList: []
    };
  },
  methods: {
    hideProduct(row) {
      productApi
        .hideProduct({ proId: row.proId, isHide: row.isHide })
        .then(res => {
          this.getProductList();
        });
    },
    newProduct() {
      this.dialogTitle = '新增产品信息';
      this.productParam = { proType: 0, isRecom: '1' };
      this.dialogImageMainUrl = '';
      this.dialogImagePrarUrl = '';
      this.dialogVisable = true;
    },
    getProductDetail(rowId, type) {
      productApi.getProduct({ proId: rowId }).then(res => {
        this.productParam = res.data;
        if (type === 1) {
          this.viewDialogVisable = true;
        } else {
          this.dialogImageMainUrl = this.productParam.picMain;
          this.dialogImagePrarUrl = this.productParam.picPara;
          this.dialogTitle = '编辑产品信息';
          this.dialogVisable = true;
        }
      });
    },
    delProduct(rowId) {
      this.$confirm('是否确认删除该产品', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          productApi.delProduct({ proId: rowId }).then(res => {
            this.getProductList();
          });
        })
        .catch(action => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    update() {
      if (this.productParam.proId) {
        productApi.upProduct(this.productParam).then(res => {
          this.getProductList();
          this.dialogVisable = false;
        });
      } else {
        productApi.addProduct(this.productParam).then(res => {
          this.getProductList();
          this.dialogVisable = false;
        });
      }
    },
    getProductList() {
      productApi.getProductList(this.searchModel).then(res => {
        this.productList = res.data.list;
        this.total = res.data.pageTotal;
      });
    },
    handleMainSuccess(res, file) {
      this.dialogImageMainUrl = res.url;
      this.productParam.picMain = res.url;
    },
    handlePraSuccess(res, file) {
      this.dialogImagePrarUrl = res.url;
      this.productParam.picPara = res.url;
    },
    praPreview(file) {
      this.dialogImagePrarUrl = file.url;
      this.imgPrarDialog = true;
    }
  },
  created() {
    this.getProductList();
  }
};
</script>
<style lang="stylus" scoped>
.el-dialog__wrapper {
  z-index: 5 !important;
}

.v-modal {
  z-index: 4 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/product/index.vue